import { Injectable } from '@angular/core';
var FileService = /** @class */ (function () {
    function FileService() {
        this.files = {};
    }
    FileService.prototype.setInit = function (targetComponents) {
        var _this = this;
        if (targetComponents === void 0) { targetComponents = []; }
        if (targetComponents.length === 0) {
            this.files = {};
        }
        else {
            targetComponents.filter(function (comp) { return typeof _this.files[comp] !== 'undefined'; }).forEach(function (comp) { return _this.files[comp] = {}; });
        }
    };
    FileService.prototype.setFile = function (compName, key, file) {
        if (typeof this.files[compName] === 'undefined') {
            this.files[compName] = {};
        }
        this.files[compName][key] = file;
    };
    FileService.prototype.getFile = function (compName, key) {
        return this.files[compName] && this.files[compName][key] ? this.files[compName][key] : new File();
    };
    FileService.prototype.getFileOption = function (file, params) {
        var ext = this.getExtension(file);
        var fileOption = fileOptions['$default'];
        if (ext) {
            var img = this.checkImageFile(ext);
            if (img) {
                fileOption = fileOptions['$image'];
            }
            else if (typeof fileOptions[ext] !== 'undefined') {
                fileOption = fileOptions[ext];
            }
            if (params && params.fileOptions) {
                if (typeof params.fileOptions['$default'] !== 'undefined') {
                    fileOption = Object.assign(new FileOption(), fileOption, params.fileOptions['$default']);
                }
                if (img && typeof params.fileOptions['$image'] !== 'undefined') {
                    fileOption = Object.assign(new FileOption(), fileOption, params.fileOptions['$image']);
                }
                if (typeof params.fileOptions[ext] !== 'undefined') {
                    fileOption = Object.assign(new FileOption(), fileOption, params.fileOptions[ext]);
                }
            }
        }
        return fileOption;
    };
    FileService.prototype.getExtension = function (file) {
        return file ? file.split('.').pop().toLowerCase() : null;
    };
    FileService.prototype.checkImageFile = function (ext) {
        return imageExtensions.indexOf(ext) >= 0 ? true : false;
    };
    FileService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    FileService.ctorParameters = function () { return []; };
    return FileService;
}());
export { FileService };
var File = /** @class */ (function () {
    function File() {
    }
    return File;
}());
var FileOption = /** @class */ (function () {
    function FileOption() {
    }
    return FileOption;
}());
export { FileOption };
var imageExtensions = ['exr', 'apng', 'bmp', 'cgm', 'drle', 'emf', 'fits', 'g3', 'gif', 'heic', 'heics', 'heif', 'heifs', 'hej2', 'hsj2', 'ief', 'jls', 'jp2', 'jpg2', 'jpeg', 'jpg', 'jpe', 'jph', 'jhc', 'jpm', 'jpx', 'jpf', 'jxr', 'jxra', 'jxrs', 'jxs', 'jxsc', 'jxsi', 'jxss', 'ktx', 'png', 'btif', 'pti', 'sgi', 'svg', 'svgz', 't38', 'tif', 'tiff', 'tfx', 'psd', 'azv', 'uvi', 'uvvi', 'uvg', 'uvvg', 'djvu', 'djv', 'sub', 'dwg', 'dxf', 'fbs', 'fpx', 'fst', 'mmr', 'rlc', 'ico', 'dds', 'mdi', 'wdp', 'npx', 'tap', 'vtf', 'wbmp', 'xif', 'pcx', 'webp', 'wmf', '3ds', 'ras', 'cmx', 'fh', 'fhc', 'fh4', 'fh5', 'fh7', 'ico', 'jng', 'sid', 'bmp', 'pcx', 'pic', 'pct', 'pnm', 'pbm', 'pgm', 'ppm', 'rgb', 'tga', 'xbm', 'xpm', 'xwd'];
var fileOptions = {
    $default: {
        img: false,
        icon: 'img/icon_file.png',
        link: true
    },
    $image: {
        img: true,
        icon: null,
        link: true
    },
    pdf: {
        img: false,
        icon: 'img/icon_pdf.png',
        link: true
    },
    xls: {
        img: false,
        icon: 'img/icon_xlsx.png',
        link: true
    },
    xlsx: {
        img: false,
        icon: 'img/icon_xlsx.png',
        link: true
    },
    doc: {
        img: false,
        icon: 'img/icon_docx.png',
        link: true
    },
    docx: {
        img: false,
        icon: 'img/icon_docx.png',
        link: true
    },
    ppt: {
        img: false,
        icon: 'img/icon_pptx.png',
        link: true
    },
    pptx: {
        img: false,
        icon: 'img/icon_pptx.png',
        link: true
    }
};
//# sourceMappingURL=file.service.js.map